import { urls } from "../api/api.urls";
import makeRequest, { makeParams } from "../api/make.request";

export default class DashboardService {

    /**
     * GET /dashboard/companyDashboardStats?period=<period>
     * period: "30d" | "3m" | "6m" | "12m" (default: "12m")
     * Returns stats, questionLibraryGrowth, verificationBreakdown and recentActivity.
     */
    static async getCompanyDashboardStats(period: string) {
        const params = makeParams([
            { index: "period", value: period },
        ]);
        return await makeRequest(urls.dashboard.companyDashboardStats + params, "GET");
    }

}
